export default "__VITE_ASSET__CNWwr8KQ__"